import React from 'react';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import Select from '../../../../../components/input/Select/Select';
import Input from '../../../../../components/input/Input/Input';
import { POINT_CAUSE_LIST_SEARCH_OPTION_MODEL } from '../../../../../store/modules/point/models';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT,
  POINT_LOG_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/pointConstants';
import './PointCauseListSearchBox.scss';

const PointCauseListSearchBox = (props) => {
  const { setData, getList, searchData } = props;
  const { type, causeName } = searchData;

  return (
    <SearchBox
      className="point-cause-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: POINT_CAUSE_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: POINT_CAUSE_LIST_SEARCH_OPTION_MODEL,
        });
      }}
    >
      {/*type 으로 검색하는 select*/}
      <BaseForm
        label="내역 종류"
        content={
          <Select
            value={type}
            list={POINT_LOG_TYPE_SELECT_LIST}
            onChange={(value) => {
              setData({
                path: ['type'],
                value,
              });
            }}
          />
        }
      />

      {/*포인트 사유*/}
      <BaseForm
        label="적립/사용처"
        content={
          <Input
            value={causeName}
            onChange={(value) =>
              setData({
                path: ['causeName'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT}
            size="large"
          />
        }
      />
    </SearchBox>
  );
};

export default PointCauseListSearchBox;
